export const educationData = [
  {
    id: 1,
    institution: "Masai School",
    course: "Full Stack Web Development",
    startYear: "2021",
    endYear: "present",
  },
  {
    id: 2,
    institution: "Truba Group of Institutes",
    course: "M.Tech in Energy Technology",
    startYear: "2021",
    endYear: "2019",
  },
  {
    id: 3,
    institution: "Technocrats Institue of Technology",
    course: "Bachelor of Civil Engineering",
    startYear: "2014",
    endYear: "2018",
  },
];
 